// extracted by css-extract-rspack-plugin
export default {"cls1":"render-cls1_maX","cls2":"render-cls2_DBq render-cls1_maX"};